import invoiceActions from 'actions/invoice';
import { Button, generateResolver, Notification, STATUS_TYPES, yup } from 'dyl-components';
import React from 'react';
import { Controller, useController, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'semantic-ui-react';

import './LogInvoiceChangeForm.scss';

const LogInvoiceChangeForm = ({
    status,
    paymentMethod,
    refresh,
    account_id,
    invoice_id
}) => {
    const { control, formState: { isValid, isDirty }, handleSubmit, trigger } = useForm({
        mode: 'onChange',
        defaultValues: {
            status: status || "",
            paymentMethod: paymentMethod === "none" ? null : paymentMethod
        },
        resolver: generateResolver({
            status: yup.string().required("This field is required"),
            paymentMethod: yup.string().when('status', {
                is: (val) => val === 'paid',
                then: schema => schema.required("Please enter valid payment method"),
                otherwise: schema => schema.nullable()
            })
        })
    });
    const { field: { name: statusName, value: statusValue, onChange: statusOnChange }, fieldState: { error: statusError } } = useController({ control, name: 'status' });
    const dispatch = useDispatch();
    const isUpdatingInvoice = useSelector(state => state.invoice.invoiceBeingUpdated);
    const onSave = async (data) => {
        try {
            const invoice_status = data.status;
            await dispatch(invoiceActions.logInvoiceChange({
                account_id,
                invoice_status,
                payment_method: invoice_status === 'open' ? "none" : data.paymentMethod || "none"
            }, null, invoice_id))
            Notification.alert("Successfully updated invoice!", STATUS_TYPES.SUCCESS);
            if (refresh) {
                refresh();
            }
        } catch (e) {
            Notification.alert("Failed to update invoice", STATUS_TYPES.ERROR);
        }
    }
    const isOpen = statusValue === 'open';
    return (
        <Form loading={isUpdatingInvoice} className='LogInvoiceChangeForm'>
            <Form.Select 
                value={statusValue}
                onChange={(_, { value }) => { 
                    statusOnChange({ target: { name: statusName, value } });
                    trigger('paymentMethod');
                }}
                error={statusError && statusError?.message}
                label='Invoice Status'
                required
                options={[
                    {
                        key: 'open', value: 'open', text: 'Open'
                    },
                    {
                        key: 'paid', value: 'paid', text: 'Paid'
                    },
                    {
                        key: 'void', value: 'void', text: 'Void'
                    }
                ]}
                selectOnBlur={false}
            />
            <Controller 
                control={control}
                name='paymentMethod'
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Select 
                        value={value}
                        required={statusValue === 'paid'}
                        disabled={isOpen}
                        {...(!value || isOpen ? { text: 'None' } : {})}
                        onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                        clearable
                        label='Payment Method'
                        options={[
                            ...(value !== 'paid' ? [ { key: null, value: null, text: 'None' } ] : []),
                            {
                                key: 'credit_card', value: 'credit_card', text: 'Credit Card'
                            },
                            {
                                key: 'debit_card', value: 'debit_card', text: 'Debit Card'
                            },
                            {
                                key: 'e-check', value: 'e-check', text: 'E-Check'
                            },
                            {
                                key: 'other', value: 'other', text: 'Other'
                            }
                        ]}
                        selectOnBlur={false}
                        error={error?.message}
                        
                    />
                )}
            />
            <Button floated='right' primary disabled={!isValid || !isDirty || isUpdatingInvoice} onClick={handleSubmit(onSave)}>
                Save
            </Button>
        </Form>
    )
}

export default LogInvoiceChangeForm;
